import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons/faSave';
import { faHourglassStart } from '@fortawesome/free-solid-svg-icons/faHourglassStart';

import Padding from '../layout/Padding.jsx';

const FormBeforeAnswer = ({
  competition: { duration },
  onSubmit = () => {},
}) => (
  <div>
    <Padding className='pos-sticky bg-light text-primary'>
      <div className="row align-items-center">
        <div className="col-md-6 offset-md-3 py-3 text-center">
          <h4 className="my-1 text-secondary">
            餘下時間: {duration}:00
          </h4>
        </div>
        <div className="col-3 d-none d-md-block text-right">
          <button
            className="btn btn-primary px-3 rounded-pill"
            disabled
          >
            <FA icon={faSave} fixedWidth />
            {' '}
            提交答案
          </button>
        </div>
      </div>
    </Padding>
    <div
      className="d-flex"
      style={{ height: 'calc(100vh - 6rem)' }}
    >
      <div className="my-auto w-100 text-center">
        <button
          className="btn btn-primary rounded-pill px-4 btn-lg"
          type="button"
          onClick={() => onSubmit()}
        >
          <FA icon={faHourglassStart} className="mr-2" />
          翻開試卷
        </button>
      </div>
    </div>
  </div>
);

export default FormBeforeAnswer;
